<template lang="pug">
div
	div.tw-mb-4.tw-flex.tw-flex-row.tw-items-center.tw-wrap(class='tw-gap-2')
		template(v-for="(trainInfo, i) in trainsInfo" :key="i")
			div.tw-mb-4.tw-flex.tw-flex-col
				div.tw-flex.tw-items-center
					img.train-icon(v-if="trainInfo.icon" :src="trainInfo.icon")
					span.tw-font-bold {{trainInfo.name}}
				span.tw-font-medium {{trainInfo.startStation}} ({{ trainInfo.startDate }}) - {{trainInfo.endStation}} ({{ trainInfo.endDate }})
			div(v-if="i < trainsInfo.length - 1") +
			p.tw-text-center.tw-grow.tw-italic.tw-font-bold.tw-text-red-500(
				v-if="!travellers && 'multi' != props.train.type"
				) {{$t('sale.customize_train', 'ATTENZIONE - Tratta non è acquistabile con questo canale.')}}
	p.tw-text-center.tw-grow.tw-italic.tw-font-bold.tw-text-red-500.tw-pb-5(
		v-if="!travellers && 'multi' == props.train.type"
	) {{$t('sale.customize_train', 'ATTENZIONE - Tratta non è acquistabile con questo canale.')}}
	div.tw-flex.tw-flex-col.tw-gap-4
		customize-traveller(
			v-for='(travellerMap, travellerXmlId, travellerIndex) in props.travellers' 
			:key='travellerXmlId'
			:traveller-xml-id="travellerXmlId"
			:traveller-offers-map="travellerMap"
			:traveller-index="travellerIndex"
			:global-offer="globalOffer"
			:train-id="props.train.id"
			@this-offer-is-for-all="setGlobalOffer"
		)
</template>

<script setup>
import {computed, ref} from 'vue';
import CustomizeTraveller from './customize-traveller.vue';
import { getTrainBreadcrumbs } from '@/common-scripts/train-helper';


const props = defineProps({
	train: Object,
	travellers: Object, // a map key/value
});
// a train can have subSegments so can have multi trains
const trainsInfo = computed(() => {
	if(!props.train) return [];
	const trains = getTrainBreadcrumbs([props.train]);
	if(!trains) return [];
	return trains.map(train => {
		const info = {
			id: train.id,
			icon: train.icon,
			name: train.name,
			startStation: train.start.stationName,
			startDate: new Date(train.departure).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit',  hour12: false}),
			endStation: train.end.stationName,
			endDate: new Date(train.arrival).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: false})
		};
		return info;
	})
});
const globalOffer = ref(null);



function setGlobalOffer(serviceAndOffer) {
	globalOffer.value = serviceAndOffer;
}
</script>

<style scoped>
img.train-icon {
  height: 0.8rem;
  margin-right: 3px;
}
</style>